import React, { useState } from 'react';
import { useKeenSlider, KeenSliderOptions } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import './styles.css';
import { classNames } from '@/utils/class-names';
import { isFunction } from 'lodash';

export const autoPlay = [
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (slider: any) => {
    let timeout: NodeJS.Timeout;
    let mouseOver = false;
    function clearNextTimeout() {
      clearTimeout(timeout);
    }
    function nextTimeout() {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        console.log(`isFunction(slider?.next)`, isFunction(slider?.next));
        if (!isFunction(slider?.next)) {
          return;
        }
        slider?.next();
      }, 5000);
    }
    slider?.on('created', () => {
      slider?.container.addEventListener('mouseover', () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider?.container.addEventListener('mouseout', () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });
    slider?.on('dragStarted', clearNextTimeout);
    slider?.on('animationEnded', nextTimeout);
    slider?.on('updated', nextTimeout);
  },
];

export default function App({
  options,
  sliders,
  sliderClassName,
  slideClassName,
  disableResponsiveDots = false,
  theme = 'dark',
}: {
  options?: KeenSliderOptions;
  sliders: React.ReactNode[];
  sliderClassName?: string;
  slideClassName?: string;
  disableResponsiveDots?: boolean;
  theme?: 'dark' | 'light';
}) {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [loaded, setLoaded] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>(
    {
      initial: 0,
      ...options,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    autoPlay,
  );

  return (
    <>
      <div className="navigation-wrapper">
        <div ref={sliderRef} className={`keen-slider ${sliderClassName || ''}`}>
          {sliders?.map((slider, index) => (
            <div className={`keen-slider__slide number-slide${index + 1} ${slideClassName || ''}`} key={index}>
              {loaded ? slider : null}
            </div>
          ))}
        </div>
      </div>
      {loaded && instanceRef.current && (
        <div className={classNames('dots mt-5', !disableResponsiveDots ? 'lg:!hidden' : '')}>
          {sliders.map((_, idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  instanceRef.current?.moveToIdx(idx);
                }}
                className={
                  'dot' + (theme === 'light' ? ' dot--light' : '') + (currentSlide === idx ? ' active' : '')
                }></button>
            );
          })}
        </div>
      )}
    </>
  );
}
